import React, { useState, useEffect } from 'react';
import '../LandingPage/App.css';
import AnimatedCards from './AnimatedCards';
import BeforeAfter from './BeforeAfter';
import SecurityTrust from './SecurityTrust';
import FAQ from './FAQ';
import BlogSection from './BlogSection';
// Assets (using SVG logos)
import googleLogo from '../Assets/google-icon-logo-svgrepo-com.svg';
import microsoftLogo from '../Assets/microsoft-logo-svgrepo-com.svg';
import amazonLogo from '../Assets/amazon-2-logo-svgrepo-com.svg';
import appleLogo from '../Assets/apple-black-logo-svgrepo-com.svg';
import metaLogo from '../Assets/snapchat-logo-svgrepo-com.svg';
import stripeLogo from '../Assets/shopify-logo-svgrepo-com.svg';
// SVG logos
import googleSvg from '../Assets/google-icon-logo-svgrepo-com.svg';
import appleSvg from '../Assets/apple-black-logo-svgrepo-com.svg';
import snapchatSvg from '../Assets/snapchat-logo-svgrepo-com.svg';
import microsoftSvg from '../Assets/microsoft-logo-svgrepo-com.svg';
import airbnbSvg from '../Assets/airbnb-2-logo-svgrepo-com.svg';
import tiktokSvg from '../Assets/tiktok-icon-white-1-logo-svgrepo-com.svg';
import netflixSvg from '../Assets/netflix-2-logo-svgrepo-com.svg';
import amazonSvg from '../Assets/amazon-2-logo-svgrepo-com.svg';
import paypalSvg from '../Assets/paypal-logo-svgrepo-com.svg';
import ibmSvg from '../Assets/ibm-logo-svgrepo-com.svg';
import uberSvg from '../Assets/uber-12-logo-svgrepo-com.svg';
import shopifySvg from '../Assets/shopify-logo-svgrepo-com.svg';
import janeStreetSvg from '../Assets/Jane_Street_id3GLGPSzf_0.svg';
import citadelSvg from '../Assets/Citadel_idFvtaoETK_0.svg';
import databricksSvg from '../Assets/Databricks_id5WLjUbLd_0.svg';
// Testimonial images removed — files no longer exist

const WordByWord = ({ text, baseDelay }) => (
  <>
    {text.split(' ').map((word, i) => (
      <span
        key={i}
        className="word-fade"
        style={{ animationDelay: `${baseDelay + i * 0.15}s` }}
      >
        {word}&nbsp;
      </span>
    ))}
  </>
);

const allNotifications = [
  {
    id: 'google',
    logo: 'google',
    title: 'Software Engineering Intern – Google',
    location: 'Mountain View, CA',
    pay: '$45/hr',
    time: 'applied 16h ago',
    status: 'pending',
    statusType: 'pending',
  },
  {
    id: 'microsoft',
    logo: 'microsoft',
    title: 'Data Science Intern – Microsoft',
    location: 'Redmond, WA',
    pay: '$42/hr',
    time: 'applied 20h ago',
    status: 'pending',
    statusType: 'pending',
  },
  {
    id: 'apple',
    logo: 'apple',
    title: 'iOS Development Intern – Apple',
    location: 'Cupertino, CA',
    pay: '$48/hr',
    time: 'applied Mar 10, 2025',
    status: 'Interview Scheduled',
    statusType: 'interview',
  },
  {
    id: 'amazon',
    logo: 'amazon',
    title: 'Full Stack Engineer Intern – Amazon',
    location: 'Seattle, WA',
    pay: '$40/hr',
    time: 'applied Mar 10, 2025',
    status: 'pending',
    statusType: 'pending',
  },
];

const extraNotifications = [
  {
    id: 'meta',
    logo: 'meta',
    title: 'Product Engineer Intern – Snap',
    location: 'Menlo Park, CA',
    pay: '$47/hr',
    time: 'just now',
    status: 'pending',
    statusType: 'pending',
  },
  {
    id: 'stripe-offer',
    logo: 'stripe',
    title: 'Backend Engineer Intern – Shopify',
    location: 'San Francisco, CA',
    pay: '$50/hr',
    time: 'just now',
    status: 'Offer Received',
    statusType: 'offer',
  },
];

const logoMap = {
  google: googleLogo,
  microsoft: microsoftLogo,
  apple: appleLogo,
  amazon: amazonLogo,
  meta: metaLogo,
  stripe: stripeLogo,
};

const Home = () => {
  const [notifications, setNotifications] = useState(allNotifications);
  const [newId, setNewId] = useState(null);
  const [removingId, setRemovingId] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const timer1 = setTimeout(() => {
      if (cancelled) return;
      setRemovingId('amazon');
      setTimeout(() => {
        if (cancelled) return;
        setNewId('meta');
        setNotifications(prev => {
          if (prev.some(n => n.id === 'meta')) return prev;
          return [extraNotifications[0], ...prev.filter(n => n.id !== 'amazon')];
        });
        setTimeout(() => { if (!cancelled) setNewId(null); }, 600);
      }, 400);
    }, 3500);

    const timer2 = setTimeout(() => {
      if (cancelled) return;
      setRemovingId('apple');
      setTimeout(() => {
        if (cancelled) return;
        setNewId('stripe-offer');
        setNotifications(prev => {
          if (prev.some(n => n.id === 'stripe-offer')) return prev;
          return [extraNotifications[1], ...prev.filter(n => n.id !== 'apple')];
        });
        setTimeout(() => { if (!cancelled) setNewId(null); }, 600);
      }, 400);
    }, 6000);

    return () => {
      cancelled = true;
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  }, []);

  return (
  <>
    {/* Hero Section */}
    <section className="hero">
      <div className="container">
        <div className="branding">
          <h1 className="word-by-word-heading">
            <WordByWord text="Stop Applying" baseDelay={0.1} />
            <br />
            <WordByWord text="Start Interviewing" baseDelay={0.4} />
          </h1>
          <p className="fade-in fade-in-2b">Our platform applies to internships and email recruiters on your behalf so you wake up to interview invites, without endless applying.</p>
          <button className="join-now-button fade-in fade-in-3b">Get Started Free</button>
        </div>
        <div className="app-window fade-in fade-in-4b">
          <div className="window-controls">
            <div className="window-control control-close" />
            <div className="window-control control-minimize" />
            <div className="window-control control-maximize" />
          </div>
          <div className="live-badge">
            <span className="live-dot" />
            Live
          </div>
          <div className="timeline">
            <div className="timeline-line" />
            <div className="timeline-item"><div className="timeline-dot" /></div>
            <div className="timeline-item"><div className="timeline-dot" /></div>
            <div className="timeline-item"><div className="timeline-dot" /></div>
          </div>
          <div className="notification-container">
            <div className="notification-header">
              <div className="notification-title">
                We applied to <b>4+ internship applications</b> and sent custom cold emails to boost your chances
              </div>
            </div>
            <ul className="notification-list">
              {notifications.map((n, i) => (
                <li
                  key={n.id}
                  className={`notification-item${newId === n.id ? ' notification-pop-in' : ''}${removingId === n.id ? ' notification-fade-out' : ''}`}
                >
                  <div className="application-icon">
                    <img src={logoMap[n.logo]} alt={n.logo} className="company-logo-img" />
                  </div>
                  <div className="application-info">
                    <div className="application-title">{n.title}</div>
                    <div className="application-meta">
                      <span className="application-tag">{n.location}</span>
                      <span className="application-tag">{n.pay}</span>
                      <span>· {n.time} · status: {n.statusType === 'pending' && <span className="status-dot" />}{n.statusType === 'interview' && <span className="status-interview">{n.status}</span>}{n.statusType === 'offer' && <span className="status-offer">{n.status}</span>}{n.statusType === 'pending' && 'pending'} · <b>cold email sent</b></span>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
            <div className="last-updated">Last updated: 2 min ago</div>
          </div>
        </div>
      </div>
    </section>

    {/* Logo Ticker Section */}
    <section id="logo-ticker" className="logo-ticker-section">
      <p className="logo-ticker-text">Our users moved forward at the following companies</p>
      <div className="logo-ticker-wrapper">
        <div className="logo-ticker-track">
          <img src={googleSvg} alt="Google" className="ticker-logo"/>
          <img src={microsoftSvg} alt="Microsoft" className="ticker-logo"/>
          <img src={amazonSvg} alt="Amazon" className="ticker-logo"/>
          <img src={appleSvg} alt="Apple" className="ticker-logo"/>
          <img src={netflixSvg} alt="Netflix" className="ticker-logo"/>
          <img src={airbnbSvg} alt="Airbnb" className="ticker-logo"/>
          <img src={uberSvg} alt="Uber" className="ticker-logo"/>
          <img src={shopifySvg} alt="Shopify" className="ticker-logo"/>
          <img src={paypalSvg} alt="PayPal" className="ticker-logo"/>
          <img src={ibmSvg} alt="IBM" className="ticker-logo"/>
          <img src={snapchatSvg} alt="Snapchat" className="ticker-logo"/>
          <img src={tiktokSvg} alt="TikTok" className="ticker-logo"/>
          <img src={janeStreetSvg} alt="Jane Street" className="ticker-logo"/>
          <img src={citadelSvg} alt="Citadel" className="ticker-logo ticker-logo--small"/>
          <img src={databricksSvg} alt="Databricks" className="ticker-logo ticker-logo--small"/>
          {/* Duplicate for seamless loop */}
          <img src={googleSvg} alt="Google" className="ticker-logo"/>
          <img src={microsoftSvg} alt="Microsoft" className="ticker-logo"/>
          <img src={amazonSvg} alt="Amazon" className="ticker-logo"/>
          <img src={appleSvg} alt="Apple" className="ticker-logo"/>
          <img src={netflixSvg} alt="Netflix" className="ticker-logo"/>
          <img src={airbnbSvg} alt="Airbnb" className="ticker-logo"/>
          <img src={uberSvg} alt="Uber" className="ticker-logo"/>
          <img src={shopifySvg} alt="Shopify" className="ticker-logo"/>
          <img src={paypalSvg} alt="PayPal" className="ticker-logo"/>
          <img src={ibmSvg} alt="IBM" className="ticker-logo"/>
          <img src={snapchatSvg} alt="Snapchat" className="ticker-logo"/>
          <img src={tiktokSvg} alt="TikTok" className="ticker-logo"/>
          <img src={janeStreetSvg} alt="Jane Street" className="ticker-logo"/>
          <img src={citadelSvg} alt="Citadel" className="ticker-logo ticker-logo--small"/>
          <img src={databricksSvg} alt="Databricks" className="ticker-logo ticker-logo--small"/>
        </div>
      </div>
    </section>

    {/* How It Works Section */}
    <section id="how-it-works" className="hiw-section">
      <div className="hiw-heading-area">
        <div className="hiw-glow" />
        <h2 className="hiw-heading">Get Started in 3 Simple Steps</h2>
        <div className="hiw-divider-line" />
        <p className="hiw-subtitle">Set it up once, and we handle applications and outreach while you focus on prep.</p>
      </div>
      <div className="dash-canvas">
        {/* Step labels with connecting line */}
        <div className="hiw-steps-row">
          <div className="hiw-step-col">
            <div className="hiw-step-circle">1</div>
            <h3 className="hiw-step-title">Connect your email</h3>
            <p className="hiw-step-desc">Link your inbox. We send applications and cold emails from your real address.</p>
          </div>
          <div className="hiw-step-col">
            <div className="hiw-step-circle">2</div>
            <h3 className="hiw-step-title">Set your preferences</h3>
            <p className="hiw-step-desc">Upload your resume and tell us what roles you want. One-time setup.</p>
          </div>
          <div className="hiw-step-col">
            <div className="hiw-step-circle">3</div>
            <h3 className="hiw-step-title">We apply for you</h3>
            <p className="hiw-step-desc">We auto-apply and cold email recruiters. You show up when the interview lands.</p>
          </div>
        </div>

        <AnimatedCards />
      </div>
    </section>

    <BeforeAfter />
    <SecurityTrust />
    <FAQ />
    <BlogSection />

  </>
  );
};

export default Home;
